export default {
  Background: 0,
  Back: 10,
  Shadows: 18,
  Particles: 19,
  Players: 20,
  Front: 30,
  Labels: 40,
};
